import { FinalCalculation } from '~/Api/User/ProductGroup/RoMaxPrice/FinalCalculation';
import { mapCalculationPrice, RawCalculationPrice } from '~/Api/User/ProductGroup/RoMaxPrice/mapCalculationPrice';
import { mapReferencedProduct, RawReferencedProduct } from '~/Api/User/ProductGroup/RoMaxPrice/mapReferencedProduct';
import { ApiClientError } from '~/ApiClient';
import Price from '~/utils/Price';

import { mapError } from './mapError';

export interface RawFinalCalculation {
	biosimilarReferencePrice: Price | null;
	canamedPrice: RawCalculationPrice | null;
	emptyResultReason: ApiClientError[];
	fxUpdatePrice: Price | null;
	genericReferencePrice: Price | null;
	prgPrbPrice: Price | null;
	priPrice: Price | null;
	publicCatalogPrice: RawCalculationPrice | null;
	referencedProduct: {
		canamed: RawReferencedProduct | null;
		publicCatalog: RawReferencedProduct | null;
	};
	referencedProductType: string | null;
	decisionNumber: string | null;
	lossOfExclusivity: string | null;
	gtin: string | null;
}

export const mapFinalCalculation = (finalCalculation: RawFinalCalculation): FinalCalculation => {
	const {
		biosimilarReferencePrice,
		canamedPrice,
		emptyResultReason,
		fxUpdatePrice,
		genericReferencePrice,
		prgPrbPrice,
		priPrice,
		publicCatalogPrice,
		referencedProduct,
	} = finalCalculation;

	return new FinalCalculation(
		biosimilarReferencePrice !== null
			? new Price(biosimilarReferencePrice.value, biosimilarReferencePrice.currency)
			: null,
		canamedPrice !== null ? mapCalculationPrice(canamedPrice) : null,
		emptyResultReason.map(mapError),
		fxUpdatePrice !== null ? new Price(fxUpdatePrice.value, fxUpdatePrice.currency) : null,
		genericReferencePrice !== null ? new Price(genericReferencePrice.value, genericReferencePrice.currency) : null,
		prgPrbPrice !== null ? new Price(prgPrbPrice.value, prgPrbPrice.currency) : null,
		priPrice !== null ? new Price(priPrice.value, priPrice.currency) : null,
		publicCatalogPrice !== null ? mapCalculationPrice(publicCatalogPrice) : null,
		{
			canamed: referencedProduct.canamed !== null ? mapReferencedProduct(referencedProduct.canamed) : null,
			publicCatalog:
				referencedProduct.publicCatalog !== null ? mapReferencedProduct(referencedProduct.publicCatalog) : null,
		},
		finalCalculation.referencedProductType,
		finalCalculation.decisionNumber,
		finalCalculation.lossOfExclusivity,
		finalCalculation.gtin
	);
};
